import {
   HTMLAttributes,
   PropsWithChildren,
   // createContext,
   // useContext,
} from "react";
import { cn } from "@/lib/utils";
import styles from "./PapooButton.module.scss";

/*
████████ ██    ██ ██████  ███████ ███████
   ██     ██  ██  ██   ██ ██      ██
   ██      ████   ██████  █████   ███████
   ██       ██    ██      ██           ██
   ██       ██    ██      ███████ ███████
*/

export type TPapooButtonStyle =
   | "default"
   | "secondary"
   | "ghost"
   | "error"
   | "success"
   | "highlight";

export type TPapooButtonSize = "normal" | "small" | "large";

/*
 ██████  ██████  ███    ██ ████████ ███████ ██   ██ ████████
██      ██    ██ ████   ██    ██    ██       ██ ██     ██
██      ██    ██ ██ ██  ██    ██    █████     ███      ██
██      ██    ██ ██  ██ ██    ██    ██       ██ ██     ██
 ██████  ██████  ██   ████    ██    ███████ ██   ██    ██
*/

// Ajouter des états et de fonctions de changement d'état
// type TContext = {
//    xxx?: string;
//    yyy?: string;
// };

// const theContext = createContext<TContext | null>(null);

/*
██████   ██████   ██████  ████████
██   ██ ██    ██ ██    ██    ██
██████  ██    ██ ██    ██    ██
██   ██ ██    ██ ██    ██    ██
██   ██  ██████   ██████     ██
*/

export interface PapooButtonProps
   extends PropsWithChildren<HTMLAttributes<HTMLButtonElement>> {
   variant?: TPapooButtonStyle;
   iconLeft?: JSX.Element;
   iconRight?: JSX.Element;
   shadow?: boolean;
   noBold?: boolean;
   disabled?: boolean;
   size?: TPapooButtonSize;
}

const PapooButton = ({
   className,
   children,
   variant,
   shadow,
   size,
   noBold,
   iconLeft,
   iconRight,
   disabled,
   ...props
}: PapooButtonProps) => {
   return (
      // <theContext.Provider
      //    value={{
      //       xxx, yyy
      //    }}
      // >
      <button
         className={cn(
            "flex select-none items-center gap-3 overflow-hidden text-nowrap rounded-lg border-[1px] border-jack-tan-200 bg-jack-tan-50 px-5 py-2 font-bold",
            className,
            size === "small"
               ? "px-3 py-1 text-[80%]"
               : size === "large"
                 ? "text-[150%]"
                 : "",
            noBold ? "font-normal" : "",
            shadow ? "shadow-md" : "",
            variant === "highlight" ? "bg-jack-tan-200" : "",
            variant === "error"
               ? "border-red-500/20 bg-red-500 text-white"
               : "",
            variant === "success"
               ? "border-jack-green-500/20 bg-jack-green-500 text-white"
               : "",
            variant === "secondary" ? "bg-white" : "",
            variant === "ghost" ? "border-0 bg-transparent" : "",
            disabled
               ? "cursor-default bg-white text-gray-300"
               : "cursor-pointer hover:brightness-90",
            styles.papoo_button,
         )}
         {...props}
      >
         {iconLeft}
         {children}
         {iconRight}
      </button>
      // </theContext.Provider>
   );
};

PapooButton.displayName = "PapooButton";

export { PapooButton };
